import { createFileRoute, notFound } from '@tanstack/react-router'

import { ThroughPilotLanding } from './index'
import { getProfileBySlug } from '../server/profileFunctions'
import { seoMeta } from '../seo'

export const Route = createFileRoute('/brief/$slug')({
  head: () => ({
    meta: seoMeta({
      title: 'ThroughPilot private brief',
      description: 'A personalized ThroughPilot project brief.',
      path: '/brief',
      noindex: true,
    }),
  }),
  loader: async ({ params }) => {
    const profile = await getProfileBySlug({ data: { slug: params.slug } })
    if (!profile) throw notFound()
    return profile
  },
  component: BriefPage,
})

function BriefPage() {
  const profile = Route.useLoaderData()
  return <ThroughPilotLanding profile={profile} />
}
